import Vue from 'vue';
import Vuex from 'vuex';
import SecureLS from 'secure-ls';

Vue.use(Vuex);

export default new Vuex.Store({
  // Para entrar en paginas cambiar layout: en lo que enruto bien
  // 'login' -> Login
  // 'password' -> Recuperacion de contraseña
  // 'problemas' -> Problemas para iniciar
  // 'Main' -> inicial
  state: {
    persistRegistryData: true,
    originalCurrentPage: 1,
    callSidebar: false,
    enableConfir: false,
    stateTotalStayConfirReser: false,
    addExtraTaxes: false,
    clearExtraCosts: false,
    usersTable: [],
    listRequeOpcionalesSeleccionadosForConfir: [],
    optionalSupplements: [],
    enableSearch: false,
    jsonProd: false,
    blockLanguagesNow: false,
    costDetailCounter: 0,
    counterSpecialMessages: 0,
    gettingClearHome: 0,
    specialMessageForDiscounts : 'N/A',
    publicMustBeClicked: false,
    confirmationNumberForIsma: '',
    closingSlider: 0,
    noTwoDaysAdded: 0,
    layout: 'problemas',
    ocultoSetting: true,
    counter: 5,
    payloadPeople: {
    infantsIn: false,
    minorsIn: false,
    maxRoomsAllowed : 0,
    showDiscountCode: false,
    showPromoCode: false,
    showAgreement: false,
    showIATA: false,
    showMotiva: false,
    },
    payload: {
      
    hotelName: '',
    hotelCode: ''

    },
    groupInfo: {
      hotelCode: '',
      groupCode: '',
      checkIn: '',
      checkOut: '',
      currencyCode: '',
      roomCodes: ''
    },
    language: 'GETTING',
    consultingReservationCode: '',
    consultingByDates: [],
    settingHotelInfo: 0,
    settingAvanzada: 0,
    nouvelleTax: 0,
    searchDataModel: {
      hotel: '',
      fechas: {
        checkin: null,
        checkout: null
      },
      tipoHabitacion: '',
      habitaciones: '',
      tipoMoneda: '',
      codigo: {
        descuento: '',
        promocion: ''
      },
    },
  },
  getters: {
    gettingListRequeOpcionalesSeleccionadosForConfir : state => {
        return state.listRequeOpcionalesSeleccionadosForConfir
    },
    gettingLangBlock: state => {
        return state.blockLanguagesNow
    },
    gettingSpecialMessages: state => {
        return state.counterSpecialMessages
    },
    gettingDiscountCode: state => {
        return state.payloadPeople.showDiscountCode
    },
    gettingPromoCode: state => {
      return state.payloadPeople.showPromoCode
    },
    gettingAgreementCode: state => {
      return state.payloadPeople.showAgreement

    },
    gettingIATACode: state => {
      return state.payloadPeople.showIATA
    },
    gettingMotivaCode: state => {
      return state.payloadPeople.showMotiva

    },
    gettingMaxRoomsAllowed: state => {
      return state.payloadPeople.maxRoomsAllowed
    },
    gettingEnfants: state => {
      return state.payloadPeople.infantsIn
    },
    gettingGars: state => {
      return state.payloadPeople.minorsIn
    },
    gettingHotelName: state => {
      return state.payload.hotelName
    },
    gettingHotelCode: state => {
      return state.payload.hotelCode
    },
    gettingGroupCode: state => {
      return state.groupInfo.groupCode
    },
    gettingGroupHotelCode: state => {
      return state.groupInfo.hotelCode
    },
    gettingCheckIn: state => {
      return state.groupInfo.checkIn
    },
    gettingCheckOut: state => {
      return state.groupInfo.checkOut
    },
    gettingCurrency: state => {
      return state.groupInfo.currencyCode
    },
    gettingRoomCodes: state => {
      return state.groupInfo.roomCodes
    },
    gettingToll: state => {
      return state.nouvelleTax
    },
    gettingAvanzada: state => {
        return state.settingAvanzada
    },
    doubleCounter: state => {
      return state.counter * 2;
    },
    gettingByDates: state => {
      return state.consultingByDates;
    },
    gettingLang: state => {
      return state.language
    },
    gettingReservationNumber: state => {
      return state.consultingReservationCode
    },
    gettingStateHotelInfo: state => {
      return state.settingHotelInfo
    },
    gettingPublicClicked: state => {
      return state.publicMustBeClicked
    },
    gettingNoTwodays: state => {
      return state.noTwoDaysAdded
    },
    gettingStatusSlider: state => {
      return state.closingSlider
    },
    gettingSpecialMessageForDiscounts: state => {
      return state.specialMessageForDiscounts
    },
    gettingClearHome: state => {
        return state.gettingClearHome
    },
    gettingCostDetailCounter: state => {
      return state.costDetailCounter
    },
    gettingConfirmationNumberForIsma: state => {
      return state.confirmationNumberForIsma
    },
    gettingEnableSearch: state => {
      return state.enableSearch
    },
    getOptionalSupplements: state => {
      return state.optionalSupplements
    },
    getJsonProd: state => {
      return state.jsonProd
    },
    getUsers: state => {
        return state.usersTable
    },
    getClearExtraCosts: state => {
      return state.clearExtraCosts
    },
    getExtraTaxes : state => {
      return state.addExtraTaxes
    },
    getTotalStayConfirReser: state => {
      return state.stateTotalStayConfirReser
    },
    getEnaConfir: state => {
      return state.enableConfir
    },
    getButton: state => {
      return state.callSidebar
    },
    getOriginalCurrentPage: state => {
      return state.originalCurrentPage
    },
    getPersistRegistryData: state => {
      return state.persistRegistryData
    }
  },
  mutations: {
    changePersistRegistryData: (state, payload) => {
        state.persistRegistryData = payload
    },
    changeOriginalCurrentPage: (state, payload) => {
      state.originalCurrentPage = payload
},
    setSidebar: (state, payload) => {
      state.callSidebar = payload
},
    solveRoutes: (state, payload) => {
      state.enableConfir = payload
},
    totalStayConfirReser: (state, payload) => {
      state.stateTotalStayConfirReser = payload
},
    addMoreTaxes: (state, payload) => {
          state.addExtraTaxes = payload
    },
    clearExtraCosts: (state,payload) => {
        state.clearExtraCosts = payload
    },
    //usersTable
    usersTable: (state, payload) => {
        state.usersTable = payload
    },
    listRequeOpcionalesSeleccionadosForConfir: (state, payload) => {
        state.listRequeOpcionalesSeleccionadosForConfir = payload

    },
    changeJsonProd: (state, payload) => {
        state.jsonProd = payload
    },
    updateTotalStay: (state, payload) => {
      state.optionalSupplements = payload
    },
    updateTotalStayII: state => {
      state.optionalSupplements = []
    },
    firstChange: (state,payload) => {
          state.enableSearch = payload.enable
    },
    blockLanguages: (state,payload) => {
        state.blockLanguagesNow = payload.turn
    },
    countSpecialMessages: state => {
        state.counterSpecialMessage++
    },
    confirmationNumberForIsma: (state,payload) => {
        state.confirmationNumberForIsma = payload
    },
    reloadCostDetail: state => {
        state.costDetailCounter++
    },
    gettingClearHome: (state) => {
        state.gettingClearHome++
    },
     specialMessageForDiscounts: (state,payload) => {
          state.specialMessageForDiscounts = payload.data
    },
    clodeSliderNow: state => {
      state.closingSlider++
    },
    noTwoDaysAnymoreReset: state => {
      state.noTwoDaysAdded = 0
    },
    noTwoDaysAnymore: state => {
      state.noTwoDaysAdded = state.noTwoDaysAdded + 1
    },
    clickPublic: state => {
      state.publicMustBeClicked = true
    },
    
    clickPublicFalse: state => {
      state.publicMustBeClicked = false
    },
    sliderPeople: (state, payloadPeople) => {
        state.payloadPeople.infantsIn = payloadPeople.letInfantsIn
        state.payloadPeople.minorsIn = payloadPeople.letMinorsIn
        state.payloadPeople.maxRoomsAllowed = payloadPeople.maxRoomsAllowed
        state.payloadPeople.showDiscountCode = payloadPeople.showDiscountCode
        state.payloadPeople.showPromoCode = payloadPeople.showPromoCode
        state.payloadPeople.showAgreement = payloadPeople.showAgreement
        state.payloadPeople.showIATA = payloadPeople.showIATA
        state.payloadPeople.showMotiva = payloadPeople.showMotiva
      },
    hotelName: (state, payload) => {
        state.payload.hotelName = payload.hotelName
        state.payload.hotelCode = payload.hotelCode
    },
    nouvelleTolls: state => {
      if(state.nouvelleTax < 10000) {
        state.nouvelleTax++
      } else {
        state.nouvelleTax = 0
        state.nouvelleTax++
      }
    },
    avanzada : state => {
      state.settingAvanzada = state.settingAvanzada + 1

    },
    hotelInfoIsSet: state => {
      state.settingHotelInfo = state.settingHotelInfo + 1
    },
    dateSlider: state => {
      var ls = new SecureLS({encodingType: 'aes'});
      var byDates =  ls.get('dateReservation')
      state.consultingByDates = byDates.data.data.response
    },
    codeSlider: state => {
      var ls = new SecureLS({encodingType: 'aes'});
      var reservationCode =  ls.get('codeReservation')
      state.consultingReservationCode = reservationCode.data.data.response.reservationNumber
    },
    switchSettings() {
      this.ocultoSetting == !this.ocultoSetting;
    },
    changeLanguageSpanish: state => {
        state.language = 'es';
    },
    changeLanguageEnglish: state => {
      state.language = 'en';
    },
    setGroupCode: (state, payload) => {
      state.groupInfo.groupCode = payload.groupCode
    },
    setHotelCode: (state, payload) => {
      state.groupInfo.hotelCode = payload.hotelCode
    },
    setCurrencyCode: (state, payload) => {
      state.groupInfo.currencyCode = payload.currencyCode
    },
    setCheckIn: (state, payload) => {
      state.groupInfo.checkIn = payload.checkIn
    },
    setCheckOut: (state, payload) => {
      state.groupInfo.checkOut = payload.checkOut
    },
    setRoomCodes: (state, payload) => {
      state.groupInfo.roomCodes = Array.isArray(payload.roomCodes)
    ? payload.roomCodes
    : [payload.roomCodes];
    },
    searchModel(store) {
      store.searchData();
    },
    
  }
});
